import MainLayout from '@/common/components/layouts/MainLayout';
import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks';
import { useNavigate } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import CategoriesList from '../components/education-list/CategoriesList';
import NewestEducation from '../components/NewestEducation';

const EducationPage = () => {
  const navigate = useNavigate();
  return (
    <MainLayout
      header="titleHeader"
      title="آموزش ها"
      navbar
      backwardHandler={() => navigate(DASHBOARD_LINKS.profile)}
    >
      <Education />
    </MainLayout>
  );
};

function Education() {
  return (
    <Box padding="24px 0px" display="flex" flexDirection="column" gap={10}>
      <CategoriesList />
      <NewestEducation cardSize="medium" />
    </Box>
  );
}
export default EducationPage;
